angular.module('bmsApp.resource')
	.controller('ResourceDirectoryDeleteDialogCtrl', [
		'notify',
		'ResourceSvc',
		'$modalInstance',
		'directory',
		function (notify,
				  ResourceSvc,
				  $modalInstance,
				  directory) {

			var self = this;
			angular.extend(self, {
				loading: false,
				promise: undefined,
				directory: directory,
				methods: {
					cancel: cancel,
					submit: submit
				}
			});

			function cancel() {
				$modalInstance.dismiss('cancel');
			}

			function submit() {
				self.promise = ResourceSvc.directory.delete(angular.extend({
					recursive: true
				}, self.directory));
				self.promise.then(function () {
					notify({
						message: 'Folder deleted successfully.'
					});
					$modalInstance.close();
				}, function (errors) {
					ResourceSvc.displayErrors(errors);
				});
			}

		}
	]);
